// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiselect {
    display: inline-block;
}

.multiselect__textfield .multiselect__textfield__input {
    text-overflow: ellipsis;
    width: calc(100% - 24px);
    padding-left: 0 !important;
}

.multiselect__item__label {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-left: 0 !important;
}

.multiselect__item__label:hover {
    background-color: #1481F719;
}

.multiselect__search-input {
    padding: 4px 6px;
}

.multiselect__search-input svg {
    color: #bdbdbd;
}

.multiselect__popper {
    z-index: 1;
}

.multiselect__buttons-container {
    display: block;
    text-align: right;
    padding: 6px 8px;
}

.multiselect__buttons-container button {
    font-weight: bolder;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/input/Select/MultipleSelect.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".multiselect {\n    display: inline-block;\n}\n\n.multiselect__textfield .multiselect__textfield__input {\n    text-overflow: ellipsis;\n    width: calc(100% - 24px);\n    padding-left: 0 !important;\n}\n\n.multiselect__item__label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    margin-left: 0 !important;\n}\n\n.multiselect__item__label:hover {\n    background-color: #1481F719;\n}\n\n.multiselect__search-input {\n    padding: 4px 6px;\n}\n\n.multiselect__search-input svg {\n    color: #bdbdbd;\n}\n\n.multiselect__popper {\n    z-index: 1;\n}\n\n.multiselect__buttons-container {\n    display: block;\n    text-align: right;\n    padding: 6px 8px;\n}\n\n.multiselect__buttons-container button {\n    font-weight: bolder;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
